import { getTaskList, completeTask } from '@this/services/task';

const state = {
  allTaskList: [],
};

const mutations = {
  setAllTaskList(state, list) {
    state.allTaskList = list;
  },
  setTaskStatus(state, task) {
    const { allTaskList } = state;
    const index = allTaskList.findIndex((item) => item.id === task.id);
    if (index > -1) {
      state.allTaskList[index].num -= 1;
    }
  },
};

const actions = {
  // 事件
  getTaskList({ commit }) {
    return getTaskList().then((res) => {
      commit('setAllTaskList', res.data);
    });
  },
  async clickTask({ dispatch }, task) {
    const { num, id } = task;
    if (num == 0 || id == 't_1') {
      dispatch('gotoTask', task);
    } else {
      dispatch('completeTask', task)
        .then(() => {
          dispatch('gotoTask', task);
          dispatch('changeTaskStatus', task);
          if(id !== 't_3'){
            dispatch('plusUserChance');  
          }
        })
        .catch(() => {
          dispatch('gotoTask', task);
        });
    }
  },
  // 步骤
  async gotoTask({ dispatch }, task) {
    const { id, url } = task;
    if (id == 't_1') {
      dispatch('goto/gotoShare', null, { root: true });
    } else if (url) {
      dispatch('goto/gotoLink', url, { root: true });
    }
  },
  completeTask({commit,rootState}, task) {
    return completeTask({
        tid: task.id,
      }).then((res) => {
        if(res.data){
          const {
                user: { userInfo },
              } = rootState;
           userInfo.money=res.data.value
           commit('user/setUserInfo', userInfo, { root: true });
        } 
      });
  },
  changeTaskStatus({ commit }, task) {
    commit('setTaskStatus', task);
  },
  plusUserChance({ commit,rootState }) {
    const {
        user: { userInfo },
      } = rootState;
   userInfo.integral+= 10;
   commit('user/setUserInfo', userInfo, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
